<template>
  <div>
    <common-banner :imgSrc="img.path" :imgLabel="img.label" :path="'/policy'" :imgType='"scroll"'></common-banner>
    <home-main>
      <template slot="slot">
        <!-- filter -->
        <el-col :span="7">
          <el-breadcrumb separator-class="el-icon-arrow-right" style="marginTop: 20px; marginBottom: 20px;">
            <el-breadcrumb-item :to="{path: '/policy'}"><i class="el-icon-s-home"></i>政策库</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path: '/policy'}"><i class="el-icon-coin"></i>条件搜索</el-breadcrumb-item>
          </el-breadcrumb>
          <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(filter, key) in filters" v-loading="filter.loading" :key="key" :name="key" :title="filter.label">
              <div class="collapse_item">
                <div class="collapse_item_li" v-for="(item, index) in filter.data" :class="{active: filter.val===item.value}" :key="index" @click="onSelect(key, item)">
                  <span style="width: 70%">{{item.label}}</span>
                  <span style="width: 10%">{{`(${item.count})`}}</span>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <!-- records -->
        <el-col :span="17" class="right-wrapper">
          <div class="advance-search">
            <policies-search  @search="advanceSearch"></policies-search>
          </div>
          <el-tag v-for="(value, key) in params" :key="key" v-show="value!==''" @close="onTagClose(key)" closable >{{key === 'subject' ? value === '1' ? '数据开放':'授权运营' : value}}</el-tag>
          <el-card v-for="record in records.data" :key="record.policyId" class="policies-card">
            <span class="title" @click="toDetail(record.policyId)">{{record.title}}</span>
            <span class="description">目标：{{record.aims}}</span>
            <p class="info">
              <span>地区：{{record.location}}</span>
              <span>发文字号：{{record.govNo}}</span>
              <span>效力等级：{{record.coverLvl}}</span>
            </p>
          </el-card>
          <el-pagination class="pagination" background layout="total, sizes, prev, pager, next" :total="records.total" :current-page.sync="pagination.page" :page-size="pagination.pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onCurrentChange" @size-change="onSizeChange"></el-pagination>
        </el-col>
      </template>
</home-main>
</div>
</template>

<script>
import CommonBanner from '@/pages/common/Banner'
import HomeMain from '@/pages/homepage/components/Main'
import PoliciesSearch from '@/pages/common/PoliciesSearch'
import {
  provinces,
  years,
  coverLvls,
  aimLvls,
  search,
  points,
  subjects
} from '@/api/policies'
export default {
  name: 'Policies',
  components: {
    CommonBanner,
    HomeMain,
    PoliciesSearch
  },
  data () {
    return {
      img: {
        path: require('@/assets/images/banner/policies_banner.jpg'),
        label: '开放数林'
      },
      activeNames: ['province', 'year', 'coverLvl', 'aimLvl'],
      pagination: {
        page: 1,
        pageSize: 10
      },
      filters: {
        province: {
          data: [],
          label: '省/自治区/直辖市',
          val: '',
          loading: false,
          query (params) {
            this.loading = true
            provinces(params).then(({
              data
            }) => {
              this.loading = false
              this.data = data
            })
          }
        },
        year: {
          data: [],
          label: '年份',
          val: '',
          loading: false,
          query (params) {
            this.loading = true
            years(params).then(({
              data
            }) => {
              this.loading = false
              this.data = data
            })
          }
        },
        // subject: {
        //   data: [],
        //   label: '主题',
        //   val: '',
        //   loading: false,
        //   query (params) {
        //     this.loading = true
        //     subjects(params).then(({
        //       data
        //     }) => {
        //       this.loading = false
        //       this.data = data
        //     })
        //   }
        // },
        coverLvl: {
          data: [],
          label: '类型',
          val: '',
          loading: false,
          query (params) {
            this.loading = true
            coverLvls(params).then(({
              data
            }) => {
              this.loading = false
              this.data = data
            })
          }
        },
        aimLvl: {
          data: [],
          label: '主题',
          val: '',
          loading: false,
          query (params) {
            this.loading = true
            aimLvls(params).then(({
              data
            }) => {
              this.loading = false
              this.data = data
            })
          }
        }
      },
      records: {
        data: [],
        total: 0,
        loading: false
      }
    }
  },
  mounted () {
    Object.values(this.filters).forEach(filter => {
      filter.query({})
    })
    this.search()
    points()
  },
  methods: {
    onSelect (key, item) {
      this.filters[key].val = item.value
      this.$forceUpdate()
      Object.keys(this.filters).filter(k => k !== key).forEach(k => {
        this.filters[k].query(this.params)
      })
      this.search()
    },
    onTagClose (key) {
      this.filters[key].val = ''
      this.$forceUpdate()
      Object.keys(this.filters).filter(k => k !== key).forEach(k => {
        this.filters[k].query(this.params)
      })
      this.search()
    },
    search () {
      this.records.data = []
      this.records.loading = true
      search({...this.params,
        ...this.pagination
      }).then(({
        data: {
          total,
          records
        }
      }) => {
        this.records.loading = false
        this.records.data = records
        this.records.total = total
      })
    },
    advanceSearch (params) {
      this.records.data = []
      this.records.loading = true
      search({...params,
        ...this.pagination
      }).then(({
        data: {
          total,
          records
        }
      }) => {
        this.records.loading = false
        this.records.data = records
        this.records.total = total
      })
    },
    toDetail (policyId) {
      this.$router.push({
        path: '/policiesDetail',
        query: {
          policyId: policyId
        }
      })
    },
    onCurrentChange (val) {
      this.pagination.page = val
      this.search()
    },
    onSizeChange (val) {
      this.pagination.pageSize = val
      this.search()
    }
  },
  computed: {
    params () {
      let params = {}
      Object.keys(this.filters).forEach(key => {
        params[key] = this.filters[key].val
      })
      return params
    }
  }
}
</script>

<style>
    .el-collapse-item__header {
        background: #009844;
        padding-left: 25px;
        font-size: 16px;
        color: white;
        height: 41px;
        border-radius: 4px;
    }
</style>

<style scoped>
    .collapse_item {
        max-height: 200px;
        overflow-y: auto;
        background: #f5f5f5;
        margin-bottom: 6px;
    }

    .collapse_item_li {
        padding-left: 18px;
        cursor: pointer;
    }

    .collapse_item_li:hover {
        color: #06c;
    }

    .collapse_item span {
        display: inline-block;
        font-size: 16px;
        font-weight: 400;
    }

    .collapse_item .active {
        color: #009844;
    }

    .policies-card {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .policies-card .title {
        color: #06c;
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 6px;
        cursor: pointer;
    }

    .policies-card .description {
        margin-top: 10px;
        line-height: 24px;
        color: #666;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
    }

    .policies-card .info {
        margin-top: 4px;
        color: #333;
        font-size: 14px;
        line-height: 24px;
    }

    .policies-card .info span {
        margin-right: 20px;
    }

    .pagination {
        margin: 20px;
    }

    .right-wrapper {
        margin: 40px 40px
    }

    .advance-search {
        margin-top: 14px;
        margin-bottom: 20px;
    }

    .advance-search /deep/ input {
        height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/PoliciesPage.vue